import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  'inline-flex items-center whitespace-nowrap justify-center font-medium text-[13px] focus:outline-none focus:ring-2 focus:ring-blue/30 focus:ring-offset-1 transition-[background-color,box-shadow,border-color,color,transform] duration-150 ease-out-strong active:scale-[0.97] disabled:pointer-events-none',
  {
    variants: {
      variant: {
        primary:
          'bg-blue rounded-button text-white shadow-button hover:bg-blue-dark active:shadow-button-active border-none',
        upgrade:
          'bg-pink-dark rounded-button text-white shadow-button hover:bg-pink-dark/90 active:shadow-button-active border-none focus:ring-pink/30',
        danger:
          'bg-red-600 rounded-button text-white shadow-button hover:bg-red-700 active:shadow-button-active border-none focus:ring-red-500/30',
        outline:
          'bg-surface border border-standard rounded-button text-neutral-700 shadow-xs hover:border-strong hover:bg-neutral-50 active:bg-neutral-100',
        ghost:
          'rounded-control text-neutral-600 hover:bg-neutral-100 hover:text-neutral-900 transition-[background-color,color,transform] duration-150 ease-out',
      },
      size: {
        md: 'h-8 px-3.5',
        sm: 'h-7 px-3 text-[13px]',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  }
);

export const buttonShineClasses = 'btn-shine-border';

export const buttonDisabledClasses =
  'cursor-default !bg-neutral-300 !text-white !border-neutral-300 !shadow-none pointer-events-none';
